import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/cjs/styles/prism';

const SyntaxHighlight = ({ children, language, ...props }) => {
  const lang = language ? language[1] : 'javascript';
  const styles = {
    margin: '0',
    background: 'rgb(23 23 23)'
  };
  return (
    <SyntaxHighlighter
      style={atomDark}
      language={lang}
      showLineNumbers
      customStyle={styles}
      {...props}
    >
      {children}
    </SyntaxHighlighter>
  );
};

export default SyntaxHighlight;
